import { render, staticRenderFns } from "./UploadFzwx.vue?vue&type=template&id=b5c1aa52&scoped=true"
import script from "./UploadFzwx.vue?vue&type=script&lang=js"
export * from "./UploadFzwx.vue?vue&type=script&lang=js"
import style0 from "./UploadFzwx.vue?vue&type=style&index=0&id=b5c1aa52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c1aa52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5c1aa52')) {
      api.createRecord('b5c1aa52', component.options)
    } else {
      api.reload('b5c1aa52', component.options)
    }
    module.hot.accept("./UploadFzwx.vue?vue&type=template&id=b5c1aa52&scoped=true", function () {
      api.rerender('b5c1aa52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Generator/components/Upload/UploadFzwx.vue"
export default component.exports